import { render, staticRenderFns } from "./SelectPriority.vue?vue&type=template&id=0769aff2"
import script from "./SelectPriority.vue?vue&type=script&lang=js"
export * from "./SelectPriority.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports